import * as React from 'react';
import { useIntl } from 'react-intl';
import SvgIconService from '../../Services/SvgIconService';

export default function GdprIcon() {
  const { formatMessage: f } = useIntl();
  const gdprIcon = SvgIconService.shiftingModeInkognito();

  return (
    <div className="b-incognito-info text-center">
      <img title={f({ id: 'widget.rideType.tooltip.yes' })} src={gdprIcon} alt="GDPR" />
    </div>
  );
}
